export default content => ({
  data: content.data
});
